module.exports = __webpack_public_path__ + "img/newface_a.714b4934.png";